module.exports = __webpack_public_path__ + "static/media/airplane.6a7796a9.jpg";